import TrendingNegativeCard from './trendingNegativeCard.component';

export default TrendingNegativeCard;